"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLuggageTypeToString = transformLuggageTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformLuggageTypeToString(luggageType) {
    switch (luggageType) {
        case legacy_enums_1.LuggageType.CarryOn:
            return "carry on";
        case legacy_enums_1.LuggageType.Suitcase:
            return "suitcase";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformLuggageTypeToString.js.map